import React from 'react'
import { Helmet } from 'react-helmet'
import { get } from 'lodash'
import connect from './tools/connect'
import initializeSkin from './tools/skinAd/index'
import updateUtm from './tools/analytics/utm'
import pageStore from './redux/page/store'
import PopupView from './views/Popup'
import Share from './views/Share'
import ErrorPage from './views/ErrorPage'
import CookieConsent from '~/components/CookieConsent'
import AppStoreSuggestion from '~/components/AppStoreSuggestion'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { nestTabModules, applyModuleData } from "~/Modules"
import lazyLoad from './tools/lazy-load-images'
import NavFocusSkipper from '~/components/NavFocusSkipper'
import Spinner from '~/components/Spinner';
import './App.css'
/*  
    Most pages use slick so we are importing it at the Base 
    so that these imports are not needed 
    everytime the <Slider /> component is used.
*/
import 'slick-carousel/slick/slick.css'
import '~/modules/Carousel/slick-theme.css'
import '~/modules/Carousel/style.scss'

class App extends React.Component {
  constructor() {
    super()
    this.showCookieConsent = this.shouldShowCookieConsent()
  }

  // TEMPORARY: whether we show the cookie consent or not should depend on an AppCMS setting
  shouldShowCookieConsent() {
    return !window.settings.internalName.includes('hoichoi')
  }

  componentDidMount() {
    updateUtm()
    initializeSkin(get(this.state, 'page.data.id'))
    setTimeout(lazyLoad, 2000)
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad)
    
  }

  triggerPageViewd(pageTitle) {
    var { title } = this.state.page || {}
    if (title) {
      var lastActivity = null
      if (document.referrer && document.referrer !== window.location.href) {
        lastActivity = document.referrer
      }
      switch (title) {
        case "Video Page":
          pageTitle = title + '-' + pageTitle.split('|')[0]
          break;
        case "Show Page":
          pageTitle = title + '-' + pageTitle.split('|')[0]
          break;
        default:
          pageTitle = title
      }
      trackEvent('Page Viewed', {
        pageName: pageTitle,
        pageURL: window.location.href,
        lastActivityName: lastActivity,
        platform: 'Web'
      })
    }
  }

  render() {
    var { title, layouts, modules, route } = this.state.page || {}
    var classes = ['app', 'appcms', window.SERVER_SIDE_RENDERING ? 'server-side-rendering' : '']
    const page = path => get(this.state.page, path)
    if (this.state.fetchingPage || this.state.adobeStatus) {
      return <Spinner />
    }

    return (
      <div className={classes.join(' ')}>
        <NavFocusSkipper />

        <Helmet
          onChangeClientState={(newState) => this.triggerPageViewd(newState.title)}>
          <title>
            {page('metadataMap.title') ? page('metadataMap.title') : `${title} | ${window.settings.site}`}
          </title>
          <meta name="description" content={page('metadataMap.description')} />
          <meta name="keywords" content={page('metadataMap.keywords')} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:title" content={page('metadataMap.title') ? page('metadataMap.title') : title} />
          <meta property="og:description" content={page('metadataMap.description')} />
          <meta property="og:site_name" content={window.settings.site} />
          <meta property="og:image" content={get(window.settings, 'images.desktopLogo')} />
          <link rel="alternate" href={window.location.href} hreflang={page('lang') || 'en'} />
          <link rel="icon" type="image/png" sizes="16x16" href={get(window.settings, 'images.favicon.16')} />
          <link rel="icon" type="image/png" sizes="32x32" href={get(window.settings, 'images.favicon.32')} />
          <link rel="shortcut icon" href={get(window.settings, 'images.favicon.ico')} />
          <link rel="canonical" href={'https://' + window.settings.domainName + route} />
        </Helmet>
        {window.settings.skinAdTag && <div id="viewlift-site-skin"></div>}

        <div role="main" className={`modules ` + (window.settings.skinAdTag && 'skin-ad')}>
          {this.loaded && window.settings.features.app_download_suggestion &&
            <AppStoreSuggestion />
          }
          {
            this.loaded &&
            this.renderModules(layouts, modules)
          }
        </div>
        {this.showCookieConsent &&
          <CookieConsent />
        }
        {this.errored && <ErrorPage error={this.state.page.error} />}
        {this.loaded && <PopupView />}
        {this.loaded && <Share />}

      </div>
    )
  }

  get errored() {
    return this.state.page.error != null;
  }

  get loaded() {
    return this.state.page && !this.state.page.error
  }

  renderModules(layouts, modules) {
    /*
        This nestTabModules conditional was added because the Template Builder does not currently
        have a way to support nesting. This is basically a hacky workaround that splits up the modules
        and nests them for pages that have a Tabs Module.
    */
    let tabModule = layouts.filter(moduleLayout => {
      if (!moduleLayout.view) {
        return false;
      }
      return moduleLayout.view.includes('Tabs');
    })

    if (tabModule.length > 0) {
      return nestTabModules(layouts, modules, tabModule);
    }
    else {
      return applyModuleData(layouts, modules)
    }
  }
}

connect(App, state => ({ page: state.data, fetchingPage: state.fetchingPage, adobeStatus: state.adobeStatus }), pageStore)

export default App;
